"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import Account from "../api/account";
import CarrierService from "../services/carrier_service";
import EmailMergerView from "./email_merger_view";
import WaitingSpinner from "../components/waiting_spinner";
function unknownCarrier() {
  return { id: "", name: `Unknown ${Account.carrierTerm()}` };
}
class EmailMergerWrapper extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: true,
      carrier: null
    });
    __publicField(this, "resolveCarrier", () => {
      if (!this.props.carrierId) {
        this.setState({ loading: false, carrier: unknownCarrier() });
        return;
      }
      CarrierService.carrierWithId(this.props.carrierId).then(
        (carrier) => {
          this.setState({ loading: false, carrier });
        },
        () => {
          this.setState({ loading: false, carrier: unknownCarrier() });
        }
      );
    });
  }
  componentDidMount() {
    this.resolveCarrier();
  }
  render() {
    if (this.state.loading) {
      return /* @__PURE__ */ jsx(WaitingSpinner, { when: true });
    }
    return /* @__PURE__ */ jsx(
      EmailMergerView,
      {
        carrier: this.state.carrier,
        emailId: this.props.emailId,
        location: { query: {} },
        onCancel: this.props.onCancel,
        mergeComplete: this.props.mergeComplete
      }
    );
  }
}
export default EmailMergerWrapper;
